module.exports = __webpack_public_path__ + "img/commitment.0bd62d2d.png";